import { EventEmitter, SimpleChanges } from '@angular/core';
import { AccountService } from '../../../core/auth/account.service';
import { Router } from "@angular/router";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../../core/auth/account.service";
import * as i3 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i4 from "@angular/common";
import * as i5 from "@fortawesome/angular-fontawesome";
import * as i6 from "../../../shared/track-user-activity.directive";
import * as i7 from "../../../shared/wellbeing-result/wellbeing-result-badge/wellbeing-result-badge.component";
function InukaJourneyComponent_tr_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelementStart(2, "div", 18);
    i0.ɵɵelement(3, "fa-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "hr", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵelement(7, "span", 22);
    i0.ɵɵelementStart(8, "div", 23);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 1, ctx_r0.startedSession.sessionStartTime.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
function InukaJourneyComponent_tr_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelementStart(2, "div", 24);
    i0.ɵɵelement(3, "fa-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "hr", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵelement(7, "span", 26);
    i0.ɵɵelementStart(8, "div", 23);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 1, ctx_r1.upcomingSession.sessionStartTime.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
function InukaJourneyComponent_tr_18_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 31);
} }
function InukaJourneyComponent_tr_18_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
} }
const _c0 = function () { return { "track": "click", "name": "home_journey_booksession_btn_clicked" }; };
function InukaJourneyComponent_tr_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 27);
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelement(2, "div", 28);
    i0.ɵɵelement(3, "hr", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵtemplate(6, InukaJourneyComponent_tr_18_span_6_Template, 1, 0, "span", 29);
    i0.ɵɵtemplate(7, InukaJourneyComponent_tr_18_span_7_Template, 1, 0, "span", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("trackUserActivity", i0.ɵɵpureFunction0(3, _c0));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r2.hasAnySession);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.hasAnySession);
} }
function InukaJourneyComponent_tr_19_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 36);
} }
function InukaJourneyComponent_tr_19_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 37);
} }
function InukaJourneyComponent_tr_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 33);
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelement(2, "div", 28);
    i0.ɵɵelement(3, "hr", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "div", 21);
    i0.ɵɵtemplate(6, InukaJourneyComponent_tr_19_span_6_Template, 1, 0, "span", 34);
    i0.ɵɵtemplate(7, InukaJourneyComponent_tr_19_span_7_Template, 1, 0, "span", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", !ctx_r3.hasAnySelfScan);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.hasAnySelfScan);
} }
function InukaJourneyComponent_tr_20_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, "Anonymous chat");
    i0.ɵɵelementEnd();
} }
function InukaJourneyComponent_tr_20_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵtext(1, "Video call");
    i0.ɵɵelementEnd();
} }
function InukaJourneyComponent_tr_20_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1, "Self scan");
    i0.ɵɵelementEnd();
} }
function InukaJourneyComponent_tr_20_wellbeing_result_badge_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "wellbeing-result-badge", 50);
} if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("wellbeingResult", item_r10.item);
} }
function InukaJourneyComponent_tr_20_a_13_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 51);
    i0.ɵɵlistener("click", function InukaJourneyComponent_tr_20_a_13_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const item_r10 = i0.ɵɵnextContext().$implicit; const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.selectSession(item_r10.item); });
    i0.ɵɵtext(1, "View Session");
    i0.ɵɵelementEnd();
} }
function InukaJourneyComponent_tr_20_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 38);
    i0.ɵɵlistener("click", function InukaJourneyComponent_tr_20_Template_tr_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r22); const item_r10 = restoredCtx.$implicit; const i_r11 = restoredCtx.index; const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.displayDetails(item_r10, i_r11); });
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelement(2, "hr", 20);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelement(4, "fa-icon", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "hr", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td");
    i0.ɵɵelementStart(7, "div", 40);
    i0.ɵɵtemplate(8, InukaJourneyComponent_tr_20_span_8_Template, 2, 0, "span", 41);
    i0.ɵɵtemplate(9, InukaJourneyComponent_tr_20_span_9_Template, 2, 0, "span", 42);
    i0.ɵɵtemplate(10, InukaJourneyComponent_tr_20_span_10_Template, 2, 0, "span", 43);
    i0.ɵɵelementStart(11, "div", 44);
    i0.ɵɵtemplate(12, InukaJourneyComponent_tr_20_wellbeing_result_badge_12_Template, 1, 1, "wellbeing-result-badge", 45);
    i0.ɵɵtemplate(13, InukaJourneyComponent_tr_20_a_13_Template, 2, 0, "a", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 23);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngIf", item_r10.type === "session" && item_r10.item.type === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r10.type === "session" && item_r10.item.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r10.type === "scan");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r10.type === "scan");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r10.type === "session");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(16, 6, item_r10.date.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
function InukaJourneyComponent_tr_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 52);
    i0.ɵɵelementStart(1, "td", 17);
    i0.ɵɵelement(2, "hr", 20);
    i0.ɵɵelementStart(3, "div", 18);
    i0.ɵɵelement(4, "fa-icon", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "div", 53);
    i0.ɵɵelementStart(7, "span", 54);
    i0.ɵɵtext(8, "Welcome to Inuka!");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 23);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 1, ctx_r5.currentAccount == null ? null : ctx_r5.currentAccount.createdDate.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
export class InukaJourneyComponent {
    constructor(router, accountService) {
        this.router = router;
        this.accountService = accountService;
        this.sessionSelected = new EventEmitter();
        this.selectedTab = 'all';
        this.selectedRow = 0;
        this.allList = [];
        this.sessionList = [];
        this.scanList = [];
        this.displayList = [];
        this.hasAnySelfScan = true;
        this.hasAnySession = true;
        this.showRegisterDate = true;
    }
    ngOnInit() {
        if (this.showRegisterDate) {
            this.accountService.getAuthenticationState().subscribe(account => {
                this.currentAccount = account;
            });
        }
    }
    ngOnChanges(changes) {
        this.allList = [];
        this.sessionList = [];
        this.scanList = [];
        this.displayList = [];
        if (this.sessions) {
            this.completedSessions = this.sessions.filter(s => s.completed);
            this.upcomingSession = this.sessions.find(s => s.future);
            this.startedSession = this.sessions.find(s => s.active);
            this.hasAnySession = this.completedSessions.length > 0 || this.upcomingSession != null;
            for (let i = 0; i < this.completedSessions.length; i++) {
                this.allList.push({
                    date: this.completedSessions[i].sessionStartTime,
                    type: 'session',
                    item: this.completedSessions[i]
                });
            }
        }
        if (this.srqHistory) {
            this.hasAnySelfScan = this.srqHistory.length > 0;
            for (let i = 0; i < this.srqHistory.length; i++) {
                this.allList.push({ date: this.srqHistory[i].dateTaken, type: 'scan', item: this.srqHistory[i] });
            }
            this.allList.sort((a, b) => {
                if (a.date.isAfter(b.date))
                    return -1;
                if (b.date.isAfter(a.date))
                    return 1;
                else
                    return 0;
            });
        }
        this.sessionList = this.allList.filter(item => item.type === 'session');
        this.scanList = this.allList.filter(item => item.type === 'scan');
        this.displayList = this.allList;
    }
    changeTab(selectedTab, selectedList) {
        this.selectedTab = selectedTab;
        this.displayList = selectedList;
    }
    displayDetails(item, index) {
        this.selectedRow = index;
        if (item.type === 'session') {
            window.open('#/session/chat/' + item.item.id + '/past', '_blank');
        }
        else if (item.type === 'scan') {
            window.open('#/wellbeing-result?scanId=' + item.item.id, '_blank');
        }
        else {
            console.log('Item type not recognized!');
        }
    }
    selectSession(session) {
        console.log(session);
        this.sessionSelected.emit(session);
    }
}
InukaJourneyComponent.ɵfac = function InukaJourneyComponent_Factory(t) { return new (t || InukaJourneyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.AccountService)); };
InukaJourneyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InukaJourneyComponent, selectors: [["inuka-journey"]], inputs: { sessions: "sessions", srqHistory: "srqHistory", showRegisterDate: "showRegisterDate" }, outputs: { sessionSelected: "sessionSelected" }, features: [i0.ɵɵNgOnChangesFeature], decls: 22, vars: 11, consts: [[1, "card", "m-0"], [1, "card-body"], [1, "row", "justify-content-between"], [1, "col-lg-6", "pr-0"], ["jhiTranslate", "inukaNgApp.inukaJourney.header"], [1, "col-lg-6", "text-lg-right"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.all", 1, "select-tab", 3, "ngClass", "click"], [1, "select-tab"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.sessions", 1, "select-tab", 3, "ngClass", "click"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.scans", 1, "select-tab", 3, "ngClass", "click"], [1, "table-responsive", "mt-4"], [1, "journey-table"], [4, "ngIf"], ["role", "button", "routerLink", "/session/schedule-session", 3, "trackUserActivity", 4, "ngIf"], ["role", "button", "routerLink", "/wellbeing-start", 4, "ngIf"], ["role", "button", 3, "click", 4, "ngFor", "ngForOf"], ["role", "button", 4, "ngIf"], [1, "journey-row-icon"], [1, "circle"], ["icon", "bell"], [1, "icon-connector"], [1, "pl-2", 2, "margin-top", "-1.3rem"], ["jhiTranslate", "inukaNgApp.inukaJourney.sessionStarted", 1, "mr-2", "text-main"], [1, "text-light", "d-lg-inline-block", "float-lg-right"], [1, "circle-light"], [1, "icon-connector", "icon-connector-light"], ["jhiTranslate", "inukaNgApp.inukaJourney.upcomingSession", 1, "mr-2", "text-main"], ["role", "button", "routerLink", "/session/schedule-session", 3, "trackUserActivity"], [1, "circle-two-color"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.book", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.bookFollowUp", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.inukaJourney.book", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.bookFollowUp", 1, "mr-2", "text-main"], ["role", "button", "routerLink", "/wellbeing-start"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.scan", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.doNewScan", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.inukaJourney.scan", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.doNewScan", 1, "mr-2", "text-main"], ["role", "button", 3, "click"], ["icon", "check"], [1, "pl-2"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.anonymousChat", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.videoCall", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.selfScan", 4, "ngIf"], [1, "d-inline-block", "float-sm-right", "float-lg-none"], [3, "wellbeingResult", 4, "ngIf"], ["class", "btn-link", "jhiTranslate", "inukaNgApp.inukaJourney.viewSession", 3, "click", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.inukaJourney.anonymousChat", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.videoCall", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.selfScan", 1, "mr-2", "text-main"], [3, "wellbeingResult"], ["jhiTranslate", "inukaNgApp.inukaJourney.viewSession", 1, "btn-link", 3, "click"], ["role", "button"], [1, "pt-2", "pl-2"], ["jhiTranslate", "inukaNgApp.inukaJourney.welcome", 1, "mr-2", "text-main"]], template: function InukaJourneyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "h3", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵelementStart(6, "span", 6);
        i0.ɵɵlistener("click", function InukaJourneyComponent_Template_span_click_6_listener() { return ctx.changeTab("all", ctx.allList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 7);
        i0.ɵɵtext(8, " | ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "span", 8);
        i0.ɵɵlistener("click", function InukaJourneyComponent_Template_span_click_9_listener() { return ctx.changeTab("session", ctx.sessionList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span", 7);
        i0.ɵɵtext(11, " | ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "span", 9);
        i0.ɵɵlistener("click", function InukaJourneyComponent_Template_span_click_12_listener() { return ctx.changeTab("scan", ctx.scanList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 10);
        i0.ɵɵelementStart(14, "table", 11);
        i0.ɵɵelementStart(15, "tbody");
        i0.ɵɵtemplate(16, InukaJourneyComponent_tr_16_Template, 11, 4, "tr", 12);
        i0.ɵɵtemplate(17, InukaJourneyComponent_tr_17_Template, 11, 4, "tr", 12);
        i0.ɵɵtemplate(18, InukaJourneyComponent_tr_18_Template, 8, 4, "tr", 13);
        i0.ɵɵtemplate(19, InukaJourneyComponent_tr_19_Template, 8, 2, "tr", 14);
        i0.ɵɵtemplate(20, InukaJourneyComponent_tr_20_Template, 17, 9, "tr", 15);
        i0.ɵɵtemplate(21, InukaJourneyComponent_tr_21_Template, 12, 4, "tr", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "all" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "session" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("font-weight-bold", ctx.selectedTab === "scan");
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "scan" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.startedSession && ctx.selectedTab !== "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.upcomingSession && ctx.selectedTab !== "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.startedSession && !ctx.upcomingSession && ctx.selectedTab !== "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.hasAnySelfScan || ctx.selectedTab === "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.displayList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showRegisterDate);
    } }, directives: [i3.JhiTranslateDirective, i4.NgClass, i4.NgIf, i4.NgForOf, i5.FaIconComponent, i1.RouterLink, i6.TrackUserActivityDirective, i7.WellbeingResultBadgeComponent], pipes: [i4.DatePipe], styles: [".table-responsive[_ngcontent-%COMP%]{height:20rem;overflow-y:scroll}.journey-table[_ngcontent-%COMP%]{width:100%;margin-bottom:1rem}.journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:center}.journey-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom}.journey-row-icon[_ngcontent-%COMP%]{text-align:center}.icon-connector[_ngcontent-%COMP%]{transform:rotate(90deg);width:100% !important;background-color:#44a38b;height:.2rem}.icon-connector-light[_ngcontent-%COMP%]{background-color:#cce9e0}.circle[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#44a38b;color:#fff;z-index:10;display:inline-block}.circle-light[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#cce9e0;color:#44a38b;z-index:10;display:inline-block}.circle-two-color[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#44a38b;color:#fff;z-index:10;display:inline-block;border:.5rem #cce9e0 solid;box-sizing:border-box}.select-tab[_ngcontent-%COMP%]{font-size:12px;font-weight:bold;padding:2px}"] });
